import { MutableRefObject, useEffect, useState } from "react";
import { getLandingContainer } from "../views/utils/getLandingContainer";

export function useOverTopScroll( ref: MutableRefObject<null> ): number {
    const [container, setContainer]     = useState<Element>( getLandingContainer() )
    const [scroll, setScroll] = useState<number>( 0 )
    const onscrollHandler = () => {
        try 
        {
            const lScroll = getLandingContainer().scrollTop
            const element = ref.current
            if(!!element){
                const iScroll = ( element as HTMLDivElement ).getBoundingClientRect().top
                const defScroll = lScroll - iScroll            
                setScroll( defScroll )
            } 
        } 
        catch (e) 
        {            
            console.log(e)            
        }
    }

    useEffect(() => {
        setContainer( getLandingContainer() ) 
    }, [ ]) 

    useEffect(() => { 
        if(!!container) {
            container.addEventListener("scroll", onscrollHandler) 
            
            return () => { 
                container.removeEventListener("scroll", onscrollHandler)
            }
        }
    }, [ container ])
    return scroll
}